import React from "react";
import { Modal, Button } from "react-bootstrap";

function ConfirmModal({
  show,
  onClose,
  onConfirm,
  title = "Confirm",
  message = "Are you sure?",
  confirmText = "OK",
  cancelText = "Cancel",
  confirmVariant = "danger",
}) {
  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>{message}</Modal.Body>

        <Modal.Footer className="justify-content-center">
        <div className="d-flex justify-content-center gap-2 w-100">
            <Button variant="secondary" onClick={onClose}>
            {cancelText}
            </Button>
            <Button variant={confirmVariant} onClick={onConfirm}>
            {confirmText}
            </Button>
        </div>
        </Modal.Footer>
    </Modal>
  );
}

export default ConfirmModal;
